import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@/lib/router';
import { useActiveLocationPermissions } from '@/redux/features/shopping-bag/hooks';
import { getWardrobePath } from '@/lib/utils/router';
import Button from '@ingka/button';
import WardrobeIcon from '@ingka/ssr-icon/paths/wardrobe';

export const ImportInventoryButton: FC = () => {
  // Hooks
  const { t } = useTranslation();
  const router = useRouter();
  const { canImportInventory } = useActiveLocationPermissions();

  if (!canImportInventory) return null;

  return (
    <Button
      type="primary"
      text={t('label.importWardrobe')}
      ssrIcon={WardrobeIcon}
      size="small"
      onClick={() => router.push(getWardrobePath())}
    />
  );
};
